export const DELIVERY_TYPE_VALUES = [
    "all" as const,
    "downloaded" as const,
    "shipped" as const,
    "mailed" as const,
    "pickedUp" as const,
];

export const FIELD_VALUES = [
    "agentLinkId" as const,
    "agentName" as const,
    "billingAccountId" as const,
    "billingAccountName" as const,
    "billingComments" as const,
    "billingTotal" as const,
    "categoryName" as const,
    "costCenter" as const,
    "creditCardTotal" as const,
    "dateOrderCompleted" as const,
    "dateOrderCreated" as const,
    "externalOrderLink" as const,
    "justListedJustSold" as const,
    "mlsNumber" as const,
    "officeId" as const,
    "officeName" as const,
    "orderName" as const,
    "orderQty" as const,
    "productType" as const,
    "programName" as const,
    "programType" as const,
    "promoCodeTotal" as const,
    "propertyAddress" as const,
    "regionName" as const,
    "salesTax" as const,
    "shippingMethod" as const,
    "shippingTotal" as const,
    "status" as const,
    "styleName" as const,
    "subcategoryName" as const,
    "subtotal" as const,
    "templateId" as const,
    "templateName" as const,
    "total" as const,
];

export const ORDER_STATUS_VALUES = [
    "completed" as const,
    "pending" as const,
];

